var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisionIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49609 17.4915L5.09535 18.0908L8.17333 14.7404L7.00206 19.1258L7.76475 19.3438L9.64423 12.2617L4.49609 17.4915Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49609 17.4915L5.09535 18.0908L8.17333 14.7404L7.00206 19.1258L7.76475 19.3438L9.64423 12.2617L4.49609 17.4915Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49609 17.4915L5.09535 18.0908L8.17333 14.7404L7.00206 19.1258L7.76475 19.3438L9.64423 12.2617L4.49609 17.4915Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49609 17.4915L5.09535 18.0908L8.17333 14.7404L7.00206 19.1258L7.76475 19.3438L9.64423 12.2617L4.49609 17.4915Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49609 17.4915L5.09535 18.0908L8.17333 14.7404L7.00206 19.1258L7.76475 19.3438L9.64423 12.2617L4.49609 17.4915Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49609 17.4915L5.09535 18.0908L8.17333 14.7404L7.00206 19.1258L7.76475 19.3438L9.64423 12.2617L4.49609 17.4915Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49609 17.4915L5.09535 18.0908L8.17333 14.7404L7.00206 19.1258L7.76475 19.3438L9.64423 12.2617L4.49609 17.4915Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49609 17.4915L5.09535 18.0908L8.17333 14.7404L7.00206 19.1258L7.76475 19.3438L9.64423 12.2617L4.49609 17.4915Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49609 17.4915L5.09535 18.0908L8.17333 14.7404L7.00206 19.1258L7.76475 19.3438L9.64423 12.2617L4.49609 17.4915Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49609 17.4915L5.09535 18.0908L8.17333 14.7404L7.00206 19.1258L7.76475 19.3438L9.64423 12.2617L4.49609 17.4915Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49609 17.4915L5.09535 18.0908L8.17333 14.7404L7.00206 19.1258L7.76475 19.3438L9.64423 12.2617L4.49609 17.4915Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49609 17.4915L5.09535 18.0908L8.17333 14.7404L7.00206 19.1258L7.76475 19.3438L9.64423 12.2617L4.49609 17.4915Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49609 17.4915L5.09535 18.0908L8.17333 14.7404L7.00206 19.1258L7.76475 19.3438L9.64423 12.2617L4.49609 17.4915Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24707 19.7911L10.0674 20.0039L11.0225 15.5557L12.2357 19.9297L13.0036 19.731L11.0341 12.6735L9.24707 19.7911Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24707 19.7911L10.0674 20.0039L11.0225 15.5557L12.2357 19.9297L13.0036 19.731L11.0341 12.6735L9.24707 19.7911Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24707 19.7911L10.0674 20.0039L11.0225 15.5557L12.2357 19.9297L13.0036 19.731L11.0341 12.6735L9.24707 19.7911Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24707 19.7911L10.0674 20.0039L11.0225 15.5557L12.2357 19.9297L13.0036 19.731L11.0341 12.6735L9.24707 19.7911Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24707 19.7911L10.0674 20.0039L11.0225 15.5557L12.2357 19.9297L13.0036 19.731L11.0341 12.6735L9.24707 19.7911Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24707 19.7911L10.0674 20.0039L11.0225 15.5557L12.2357 19.9297L13.0036 19.731L11.0341 12.6735L9.24707 19.7911Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24707 19.7911L10.0674 20.0039L11.0225 15.5557L12.2357 19.9297L13.0036 19.731L11.0341 12.6735L9.24707 19.7911Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24707 19.7911L10.0674 20.0039L11.0225 15.5557L12.2357 19.9297L13.0036 19.731L11.0341 12.6735L9.24707 19.7911Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24707 19.7911L10.0674 20.0039L11.0225 15.5557L12.2357 19.9297L13.0036 19.731L11.0341 12.6735L9.24707 19.7911Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24707 19.7911L10.0674 20.0039L11.0225 15.5557L12.2357 19.9297L13.0036 19.731L11.0341 12.6735L9.24707 19.7911Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24707 19.7911L10.0674 20.0039L11.0225 15.5557L12.2357 19.9297L13.0036 19.731L11.0341 12.6735L9.24707 19.7911Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24707 19.7911L10.0674 20.0039L11.0225 15.5557L12.2357 19.9297L13.0036 19.731L11.0341 12.6735L9.24707 19.7911Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24707 19.7911L10.0674 20.0039L11.0225 15.5557L12.2357 19.9297L13.0036 19.731L11.0341 12.6735L9.24707 19.7911Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1876 19.3438L15.0088 19.1345L13.6996 14.7773L16.8723 18.0235L17.4491 17.479L12.3193 12.2471L14.1876 19.3438Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1876 19.3438L15.0088 19.1345L13.6996 14.7773L16.8723 18.0235L17.4491 17.479L12.3193 12.2471L14.1876 19.3438Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1876 19.3438L15.0088 19.1345L13.6996 14.7773L16.8723 18.0235L17.4491 17.479L12.3193 12.2471L14.1876 19.3438Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1876 19.3438L15.0088 19.1345L13.6996 14.7773L16.8723 18.0235L17.4491 17.479L12.3193 12.2471L14.1876 19.3438Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1876 19.3438L15.0088 19.1345L13.6996 14.7773L16.8723 18.0235L17.4491 17.479L12.3193 12.2471L14.1876 19.3438Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1876 19.3438L15.0088 19.1345L13.6996 14.7773L16.8723 18.0235L17.4491 17.479L12.3193 12.2471L14.1876 19.3438Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1876 19.3438L15.0088 19.1345L13.6996 14.7773L16.8723 18.0235L17.4491 17.479L12.3193 12.2471L14.1876 19.3438Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1876 19.3438L15.0088 19.1345L13.6996 14.7773L16.8723 18.0235L17.4491 17.479L12.3193 12.2471L14.1876 19.3438Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1876 19.3438L15.0088 19.1345L13.6996 14.7773L16.8723 18.0235L17.4491 17.479L12.3193 12.2471L14.1876 19.3438Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1876 19.3438L15.0088 19.1345L13.6996 14.7773L16.8723 18.0235L17.4491 17.479L12.3193 12.2471L14.1876 19.3438Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1876 19.3438L15.0088 19.1345L13.6996 14.7773L16.8723 18.0235L17.4491 17.479L12.3193 12.2471L14.1876 19.3438Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1876 19.3438L15.0088 19.1345L13.6996 14.7773L16.8723 18.0235L17.4491 17.479L12.3193 12.2471L14.1876 19.3438Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1876 19.3438L15.0088 19.1345L13.6996 14.7773L16.8723 18.0235L17.4491 17.479L12.3193 12.2471L14.1876 19.3438Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5874 16.5586L19.1893 15.9619L15.8522 12.8696L20.2326 14.0597L20.4538 13.298L13.3799 11.388L18.5874 16.5586Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5874 16.5586L19.1893 15.9619L15.8522 12.8696L20.2326 14.0597L20.4538 13.298L13.3799 11.388L18.5874 16.5586Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5874 16.5586L19.1893 15.9619L15.8522 12.8696L20.2326 14.0597L20.4538 13.298L13.3799 11.388L18.5874 16.5586Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5874 16.5586L19.1893 15.9619L15.8522 12.8696L20.2326 14.0597L20.4538 13.298L13.3799 11.388L18.5874 16.5586Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5874 16.5586L19.1893 15.9619L15.8522 12.8696L20.2326 14.0597L20.4538 13.298L13.3799 11.388L18.5874 16.5586Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5874 16.5586L19.1893 15.9619L15.8522 12.8696L20.2326 14.0597L20.4538 13.298L13.3799 11.388L18.5874 16.5586Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5874 16.5586L19.1893 15.9619L15.8522 12.8696L20.2326 14.0597L20.4538 13.298L13.3799 11.388L18.5874 16.5586Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5874 16.5586L19.1893 15.9619L15.8522 12.8696L20.2326 14.0597L20.4538 13.298L13.3799 11.388L18.5874 16.5586Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5874 16.5586L19.1893 15.9619L15.8522 12.8696L20.2326 14.0597L20.4538 13.298L13.3799 11.388L18.5874 16.5586Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5874 16.5586L19.1893 15.9619L15.8522 12.8696L20.2326 14.0597L20.4538 13.298L13.3799 11.388L18.5874 16.5586Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5874 16.5586L19.1893 15.9619L15.8522 12.8696L20.2326 14.0597L20.4538 13.298L13.3799 11.388L18.5874 16.5586Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5874 16.5586L19.1893 15.9619L15.8522 12.8696L20.2326 14.0597L20.4538 13.298L13.3799 11.388L18.5874 16.5586Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5874 16.5586L19.1893 15.9619L15.8522 12.8696L20.2326 14.0597L20.4538 13.298L13.3799 11.388L18.5874 16.5586Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6247 2.51631L17.0254 1.91707L13.9475 5.2674L15.1187 0.881997L14.356 0.664092L12.4766 7.74609L17.6247 2.51631Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6247 2.51631L17.0254 1.91707L13.9475 5.2674L15.1187 0.881997L14.356 0.664092L12.4766 7.74609L17.6247 2.51631Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6247 2.51631L17.0254 1.91707L13.9475 5.2674L15.1187 0.881997L14.356 0.664092L12.4766 7.74609L17.6247 2.51631Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6247 2.51631L17.0254 1.91707L13.9475 5.2674L15.1187 0.881997L14.356 0.664092L12.4766 7.74609L17.6247 2.51631Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6247 2.51631L17.0254 1.91707L13.9475 5.2674L15.1187 0.881997L14.356 0.664092L12.4766 7.74609L17.6247 2.51631Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6247 2.51631L17.0254 1.91707L13.9475 5.2674L15.1187 0.881997L14.356 0.664092L12.4766 7.74609L17.6247 2.51631Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6247 2.51631L17.0254 1.91707L13.9475 5.2674L15.1187 0.881997L14.356 0.664092L12.4766 7.74609L17.6247 2.51631Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6247 2.51631L17.0254 1.91707L13.9475 5.2674L15.1187 0.881997L14.356 0.664092L12.4766 7.74609L17.6247 2.51631Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6247 2.51631L17.0254 1.91707L13.9475 5.2674L15.1187 0.881997L14.356 0.664092L12.4766 7.74609L17.6247 2.51631Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6247 2.51631L17.0254 1.91707L13.9475 5.2674L15.1187 0.881997L14.356 0.664092L12.4766 7.74609L17.6247 2.51631Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6247 2.51631L17.0254 1.91707L13.9475 5.2674L15.1187 0.881997L14.356 0.664092L12.4766 7.74609L17.6247 2.51631Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6247 2.51631L17.0254 1.91707L13.9475 5.2674L15.1187 0.881997L14.356 0.664092L12.4766 7.74609L17.6247 2.51631Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6247 2.51631L17.0254 1.91707L13.9475 5.2674L15.1187 0.881997L14.356 0.664092L12.4766 7.74609L17.6247 2.51631Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8737 0.214461L12.0534 0.00163412L11.0983 4.44979L9.88508 0.0758142L9.11719 0.274548L11.0867 7.33203L12.8737 0.214461Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8737 0.214461L12.0534 0.00163412L11.0983 4.44979L9.88508 0.0758142L9.11719 0.274548L11.0867 7.33203L12.8737 0.214461Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8737 0.214461L12.0534 0.00163412L11.0983 4.44979L9.88508 0.0758142L9.11719 0.274548L11.0867 7.33203L12.8737 0.214461Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8737 0.214461L12.0534 0.00163412L11.0983 4.44979L9.88508 0.0758142L9.11719 0.274548L11.0867 7.33203L12.8737 0.214461Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8737 0.214461L12.0534 0.00163412L11.0983 4.44979L9.88508 0.0758142L9.11719 0.274548L11.0867 7.33203L12.8737 0.214461Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8737 0.214461L12.0534 0.00163412L11.0983 4.44979L9.88508 0.0758142L9.11719 0.274548L11.0867 7.33203L12.8737 0.214461Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8737 0.214461L12.0534 0.00163412L11.0983 4.44979L9.88508 0.0758142L9.11719 0.274548L11.0867 7.33203L12.8737 0.214461Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8737 0.214461L12.0534 0.00163412L11.0983 4.44979L9.88508 0.0758142L9.11719 0.274548L11.0867 7.33203L12.8737 0.214461Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8737 0.214461L12.0534 0.00163412L11.0983 4.44979L9.88508 0.0758142L9.11719 0.274548L11.0867 7.33203L12.8737 0.214461Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8737 0.214461L12.0534 0.00163412L11.0983 4.44979L9.88508 0.0758142L9.11719 0.274548L11.0867 7.33203L12.8737 0.214461Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8737 0.214461L12.0534 0.00163412L11.0983 4.44979L9.88508 0.0758142L9.11719 0.274548L11.0867 7.33203L12.8737 0.214461Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8737 0.214461L12.0534 0.00163412L11.0983 4.44979L9.88508 0.0758142L9.11719 0.274548L11.0867 7.33203L12.8737 0.214461Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8737 0.214461L12.0534 0.00163412L11.0983 4.44979L9.88508 0.0758142L9.11719 0.274548L11.0867 7.33203L12.8737 0.214461Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8897 11.8711L21.1102 11.0528L16.6711 10.056L21.0563 8.88397L20.8648 8.11425L13.7891 10.0174L20.8897 11.8711Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8897 11.8711L21.1102 11.0528L16.6711 10.056L21.0563 8.88397L20.8648 8.11425L13.7891 10.0174L20.8897 11.8711Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8897 11.8711L21.1102 11.0528L16.6711 10.056L21.0563 8.88397L20.8648 8.11425L13.7891 10.0174L20.8897 11.8711Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8897 11.8711L21.1102 11.0528L16.6711 10.056L21.0563 8.88397L20.8648 8.11425L13.7891 10.0174L20.8897 11.8711Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8897 11.8711L21.1102 11.0528L16.6711 10.056L21.0563 8.88397L20.8648 8.11425L13.7891 10.0174L20.8897 11.8711Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8897 11.8711L21.1102 11.0528L16.6711 10.056L21.0563 8.88397L20.8648 8.11425L13.7891 10.0174L20.8897 11.8711Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8897 11.8711L21.1102 11.0528L16.6711 10.056L21.0563 8.88397L20.8648 8.11425L13.7891 10.0174L20.8897 11.8711Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8897 11.8711L21.1102 11.0528L16.6711 10.056L21.0563 8.88397L20.8648 8.11425L13.7891 10.0174L20.8897 11.8711Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8897 11.8711L21.1102 11.0528L16.6711 10.056L21.0563 8.88397L20.8648 8.11425L13.7891 10.0174L20.8897 11.8711Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8897 11.8711L21.1102 11.0528L16.6711 10.056L21.0563 8.88397L20.8648 8.11425L13.7891 10.0174L20.8897 11.8711Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8897 11.8711L21.1102 11.0528L16.6711 10.056L21.0563 8.88397L20.8648 8.11425L13.7891 10.0174L20.8897 11.8711Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8897 11.8711L21.1102 11.0528L16.6711 10.056L21.0563 8.88397L20.8648 8.11425L13.7891 10.0174L20.8897 11.8711Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8897 11.8711L21.1102 11.0528L16.6711 10.056L21.0563 8.88397L20.8648 8.11425L13.7891 10.0174L20.8897 11.8711Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4491 6.6708L20.2245 5.85366L15.8926 7.24437L19.0787 4.01134L18.5235 3.44489L13.3887 8.67188L20.4491 6.6708Z",
    fill: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4491 6.6708L20.2245 5.85366L15.8926 7.24437L19.0787 4.01134L18.5235 3.44489L13.3887 8.67188L20.4491 6.6708Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4491 6.6708L20.2245 5.85366L15.8926 7.24437L19.0787 4.01134L18.5235 3.44489L13.3887 8.67188L20.4491 6.6708Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4491 6.6708L20.2245 5.85366L15.8926 7.24437L19.0787 4.01134L18.5235 3.44489L13.3887 8.67188L20.4491 6.6708Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4491 6.6708L20.2245 5.85366L15.8926 7.24437L19.0787 4.01134L18.5235 3.44489L13.3887 8.67188L20.4491 6.6708Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4491 6.6708L20.2245 5.85366L15.8926 7.24437L19.0787 4.01134L18.5235 3.44489L13.3887 8.67188L20.4491 6.6708Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4491 6.6708L20.2245 5.85366L15.8926 7.24437L19.0787 4.01134L18.5235 3.44489L13.3887 8.67188L20.4491 6.6708Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4491 6.6708L20.2245 5.85366L15.8926 7.24437L19.0787 4.01134L18.5235 3.44489L13.3887 8.67188L20.4491 6.6708Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4491 6.6708L20.2245 5.85366L15.8926 7.24437L19.0787 4.01134L18.5235 3.44489L13.3887 8.67188L20.4491 6.6708Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4491 6.6708L20.2245 5.85366L15.8926 7.24437L19.0787 4.01134L18.5235 3.44489L13.3887 8.67188L20.4491 6.6708Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4491 6.6708L20.2245 5.85366L15.8926 7.24437L19.0787 4.01134L18.5235 3.44489L13.3887 8.67188L20.4491 6.6708Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4491 6.6708L20.2245 5.85366L15.8926 7.24437L19.0787 4.01134L18.5235 3.44489L13.3887 8.67188L20.4491 6.6708Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4491 6.6708L20.2245 5.85366L15.8926 7.24437L19.0787 4.01134L18.5235 3.44489L13.3887 8.67188L20.4491 6.6708Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33132 16.5312L2.72999 15.9341L6.06969 12.8445L1.68833 14.031L1.46777 13.2691L8.54331 11.3651L3.33132 16.5312Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33132 16.5312L2.72999 15.9341L6.06969 12.8445L1.68833 14.031L1.46777 13.2691L8.54331 11.3651L3.33132 16.5312Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33132 16.5312L2.72999 15.9341L6.06969 12.8445L1.68833 14.031L1.46777 13.2691L8.54331 11.3651L3.33132 16.5312Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33132 16.5312L2.72999 15.9341L6.06969 12.8445L1.68833 14.031L1.46777 13.2691L8.54331 11.3651L3.33132 16.5312Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33132 16.5312L2.72999 15.9341L6.06969 12.8445L1.68833 14.031L1.46777 13.2691L8.54331 11.3651L3.33132 16.5312Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33132 16.5312L2.72999 15.9341L6.06969 12.8445L1.68833 14.031L1.46777 13.2691L8.54331 11.3651L3.33132 16.5312Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33132 16.5312L2.72999 15.9341L6.06969 12.8445L1.68833 14.031L1.46777 13.2691L8.54331 11.3651L3.33132 16.5312Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33132 16.5312L2.72999 15.9341L6.06969 12.8445L1.68833 14.031L1.46777 13.2691L8.54331 11.3651L3.33132 16.5312Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33132 16.5312L2.72999 15.9341L6.06969 12.8445L1.68833 14.031L1.46777 13.2691L8.54331 11.3651L3.33132 16.5312Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33132 16.5312L2.72999 15.9341L6.06969 12.8445L1.68833 14.031L1.46777 13.2691L8.54331 11.3651L3.33132 16.5312Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33132 16.5312L2.72999 15.9341L6.06969 12.8445L1.68833 14.031L1.46777 13.2691L8.54331 11.3651L3.33132 16.5312Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33132 16.5312L2.72999 15.9341L6.06969 12.8445L1.68833 14.031L1.46777 13.2691L8.54331 11.3651L3.33132 16.5312Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33132 16.5312L2.72999 15.9341L6.06969 12.8445L1.68833 14.031L1.46777 13.2691L8.54331 11.3651L3.33132 16.5312Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M1.10337 11.8125L0.887695 10.9929L5.33258 10.0224L0.954367 8.82445L1.15044 8.05587L8.2148 10.0009L1.10337 11.8125Z",
    fill: "black"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M1.10337 11.8125L0.887695 10.9929L5.33258 10.0224L0.954367 8.82445L1.15044 8.05587L8.2148 10.0009L1.10337 11.8125Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M1.10337 11.8125L0.887695 10.9929L5.33258 10.0224L0.954367 8.82445L1.15044 8.05587L8.2148 10.0009L1.10337 11.8125Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M1.10337 11.8125L0.887695 10.9929L5.33258 10.0224L0.954367 8.82445L1.15044 8.05587L8.2148 10.0009L1.10337 11.8125Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M1.10337 11.8125L0.887695 10.9929L5.33258 10.0224L0.954367 8.82445L1.15044 8.05587L8.2148 10.0009L1.10337 11.8125Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M1.10337 11.8125L0.887695 10.9929L5.33258 10.0224L0.954367 8.82445L1.15044 8.05587L8.2148 10.0009L1.10337 11.8125Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M1.10337 11.8125L0.887695 10.9929L5.33258 10.0224L0.954367 8.82445L1.15044 8.05587L8.2148 10.0009L1.10337 11.8125Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M1.10337 11.8125L0.887695 10.9929L5.33258 10.0224L0.954367 8.82445L1.15044 8.05587L8.2148 10.0009L1.10337 11.8125Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M1.10337 11.8125L0.887695 10.9929L5.33258 10.0224L0.954367 8.82445L1.15044 8.05587L8.2148 10.0009L1.10337 11.8125Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M1.10337 11.8125L0.887695 10.9929L5.33258 10.0224L0.954367 8.82445L1.15044 8.05587L8.2148 10.0009L1.10337 11.8125Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M1.10337 11.8125L0.887695 10.9929L5.33258 10.0224L0.954367 8.82445L1.15044 8.05587L8.2148 10.0009L1.10337 11.8125Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M1.10337 11.8125L0.887695 10.9929L5.33258 10.0224L0.954367 8.82445L1.15044 8.05587L8.2148 10.0009L1.10337 11.8125Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M1.10337 11.8125L0.887695 10.9929L5.33258 10.0224L0.954367 8.82445L1.15044 8.05587L8.2148 10.0009L1.10337 11.8125Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93241 0.661133L7.11119 0.87042L8.42038 5.22755L5.24767 1.98136L4.6709 2.52588L9.80066 7.75781L7.93241 0.661133Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93241 0.661133L7.11119 0.87042L8.42038 5.22755L5.24767 1.98136L4.6709 2.52588L9.80066 7.75781L7.93241 0.661133Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93241 0.661133L7.11119 0.87042L8.42038 5.22755L5.24767 1.98136L4.6709 2.52588L9.80066 7.75781L7.93241 0.661133Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93241 0.661133L7.11119 0.87042L8.42038 5.22755L5.24767 1.98136L4.6709 2.52588L9.80066 7.75781L7.93241 0.661133Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93241 0.661133L7.11119 0.87042L8.42038 5.22755L5.24767 1.98136L4.6709 2.52588L9.80066 7.75781L7.93241 0.661133Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93241 0.661133L7.11119 0.87042L8.42038 5.22755L5.24767 1.98136L4.6709 2.52588L9.80066 7.75781L7.93241 0.661133Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93241 0.661133L7.11119 0.87042L8.42038 5.22755L5.24767 1.98136L4.6709 2.52588L9.80066 7.75781L7.93241 0.661133Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93241 0.661133L7.11119 0.87042L8.42038 5.22755L5.24767 1.98136L4.6709 2.52588L9.80066 7.75781L7.93241 0.661133Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93241 0.661133L7.11119 0.87042L8.42038 5.22755L5.24767 1.98136L4.6709 2.52588L9.80066 7.75781L7.93241 0.661133Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93241 0.661133L7.11119 0.87042L8.42038 5.22755L5.24767 1.98136L4.6709 2.52588L9.80066 7.75781L7.93241 0.661133Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93241 0.661133L7.11119 0.87042L8.42038 5.22755L5.24767 1.98136L4.6709 2.52588L9.80066 7.75781L7.93241 0.661133Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93241 0.661133L7.11119 0.87042L8.42038 5.22755L5.24767 1.98136L4.6709 2.52588L9.80066 7.75781L7.93241 0.661133Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93241 0.661133L7.11119 0.87042L8.42038 5.22755L5.24767 1.98136L4.6709 2.52588L9.80066 7.75781L7.93241 0.661133Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5304 3.44658L2.92856 4.04324L6.26561 7.13561L1.88527 5.94543L1.66406 6.70716L8.73796 8.61719L3.5304 3.44658Z",
    fill: "black"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5304 3.44658L2.92856 4.04324L6.26561 7.13561L1.88527 5.94543L1.66406 6.70716L8.73796 8.61719L3.5304 3.44658Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5304 3.44658L2.92856 4.04324L6.26561 7.13561L1.88527 5.94543L1.66406 6.70716L8.73796 8.61719L3.5304 3.44658Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5304 3.44658L2.92856 4.04324L6.26561 7.13561L1.88527 5.94543L1.66406 6.70716L8.73796 8.61719L3.5304 3.44658Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5304 3.44658L2.92856 4.04324L6.26561 7.13561L1.88527 5.94543L1.66406 6.70716L8.73796 8.61719L3.5304 3.44658Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5304 3.44658L2.92856 4.04324L6.26561 7.13561L1.88527 5.94543L1.66406 6.70716L8.73796 8.61719L3.5304 3.44658Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5304 3.44658L2.92856 4.04324L6.26561 7.13561L1.88527 5.94543L1.66406 6.70716L8.73796 8.61719L3.5304 3.44658Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5304 3.44658L2.92856 4.04324L6.26561 7.13561L1.88527 5.94543L1.66406 6.70716L8.73796 8.61719L3.5304 3.44658Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5304 3.44658L2.92856 4.04324L6.26561 7.13561L1.88527 5.94543L1.66406 6.70716L8.73796 8.61719L3.5304 3.44658Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5304 3.44658L2.92856 4.04324L6.26561 7.13561L1.88527 5.94543L1.66406 6.70716L8.73796 8.61719L3.5304 3.44658Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5304 3.44658L2.92856 4.04324L6.26561 7.13561L1.88527 5.94543L1.66406 6.70716L8.73796 8.61719L3.5304 3.44658Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5304 3.44658L2.92856 4.04324L6.26561 7.13561L1.88527 5.94543L1.66406 6.70716L8.73796 8.61719L3.5304 3.44658Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5304 3.44658L2.92856 4.04324L6.26561 7.13561L1.88527 5.94543L1.66406 6.70716L8.73796 8.61719L3.5304 3.44658Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionIcon);
export default __webpack_public_path__ + "static/media/VisionIcon.a12ca20855a8510a370566559493cce4.svg";
export { ForwardRef as ReactComponent };